import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import {
  campaignExecutionsCountSuccess,
  campaignExecutionsSuccess,
  closeCostModal,
  closeRecipientsModal,
  controlGroupChanged,
  costChanged,
  excludedChanged,
  loadColumns,
  openCostModal,
  openRecipientsModal,
  pagingChanged,
} from '../actions/campaign-executions.actions';
import { CloseSidenav } from '../actions/sidenav.actions';

export interface CampaignExecutionsState extends EntityState<any> {
  columns: { [label: string]: string };
  totalResults: number;
  itemsNumber: number;
  paginator: {
    previousPageIndex: number;
    pageIndex: number;
    pageSize: number;
    length: number;
  };
  selectedRow: any;
  campaignExecutionCost: number;
  controlGroup: boolean;
  excluded: boolean;
}

export const campaignExecutionsAdapter = createEntityAdapter<any>();

const initialState: CampaignExecutionsState = campaignExecutionsAdapter.getInitialState({
  columns: {},
  totalResults: 0,
  itemsNumber: 10,
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
  selectedRow: null,
  campaignExecutionCost: 0,
  controlGroup: false,
  excluded: false,
});

export const campaignExecutionsReducer = createReducer(
  initialState,
  on(loadColumns, (state, { columns }) => ({
    ...state,
    columns,
  })),
  on(campaignExecutionsCountSuccess, (state, { count }) => ({
    ...state,
    totalResults: count,
  })),
  on(campaignExecutionsSuccess, (state, { data }) => {
    const executionsData = data.map((item: any) => ({
      id: item.campaignExecutionId,
      title: item.campaignExecutionTitle,
      description: item.campaignExecutionDescription,
      date: item.campaignExecutionDate,
      country: item.campaignExecutionCountryId,
      schema: item.campaignExecutionLoyaltySchemaId,
      channel: item.campaignCommunicationChannel,
      cost: item.campaignExecutionCost,
      group: item.controGroupPercentage,
      members: item.campaignExecutionLinesCount,
      percentage: item.progressPercentage,
      canceled: item.canceled,
    }));
    return campaignExecutionsAdapter.setAll(executionsData, { ...state });
  }),
  on(pagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(openCostModal, (state, { selectedRow }) => ({
    ...state,
    selectedRow,
  })),
  on(openRecipientsModal, (state, { selectedRow }) => ({
    ...state,
    selectedRow,
  })),
  on(costChanged, (state, { updatedCostValue }) => ({
    ...state,
    campaignExecutionCost: updatedCostValue,
  })),
  on(closeCostModal, (state) => ({
    ...state,
    selectedRow: null,
    campaignExecutionCost: state.campaignExecutionCost,
  })),
  on(closeRecipientsModal, (state) => ({
    ...state,
    selectedRow: null,
    controlGroup: false,
    excluded: false,
  })),
  on(controlGroupChanged, (state) => ({
    ...state,
    controlGroup: !state.controlGroup,
  })),
  on(excludedChanged, (state) => ({
    ...state,
    excluded: !state.excluded,
  })),
  on(CloseSidenav, () => initialState),
);
